"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    errorMessages: {
        assessmentLoad: 'Unable to fetch assessment data',
        scoreReviewAssessment: 'Unable to fetch score and review assessment data',
        upcomingAssessment: 'Unable to fetch upcoming assessment data',
        liveAssessment: 'Unable to fetch now live assessment data',
        assessmentRecommend: 'Unable to fetch assessment recommendations',
        assessmentList: 'Unable to fetch the assessments list',
        assignmentList: 'Unable to fetch the assignments list',
        scheduledAssessmentList: 'Unable to fetch the scheduled assessment list',
        questions: 'Unable to fetch the questions',
        lowestPerforming: 'Unable to fetch the lowest performing assessment data',
        schoolList: 'Unable to fetch the schools list',
        selectClass: 'Unable to select class',
        teacherList: 'Unable to fetch the teachers list',
        domainList: 'Unable to fetch the domain list',
        resetFilters: 'Unable to reset the filters',
        schoolDetails: 'Unable to fetch school details',
        efkDetails: 'Unable to fetch the foundational knowledge details',
        studentList: 'Unable to fetch the student data',
        studentSummary: 'Unable to fetch the submitted and unattempted students count',
        studentReportSummary: 'Unable to fetch the completed and pending assessment count for selected student',
        avgScoreDetails: 'Unable to load average score details',
        classList: 'Unable to fetch the class list',
        oopsErr: 'Oops...',
        assessmentDelete: 'Unable to delete the assessment',
        assessmentFinish: 'Unable to finish the assessment',
        assessmentLaunch: 'Unable to launch the assessment',
        assessmentReopen: 'Unable to reopen the assessment',
        assessmentStart: 'Unable to start the assessment',
        standardsData: 'Unable to fetch the standards data',
        standardPerformance: 'Unable to fetch the standards performance data',
        assessmentCopy: 'Unable to copy the assessment',
        assessmentCreation: 'Unable to create assessment',
        viewRubric: 'Unable to fetch rubrics data',
        saveRubric: 'Unable to save rubrics data',
        previewAssessment: 'Unable to preview the assessment',
        publishAssessment: 'Unable to publish the assessment',
        submitAssessment: 'Unable to submit the assessment',
        shareAssessment: 'Unable to share the assessment',
        closeAssessment: 'Unable to close the assessment',
        saveAssessment: 'Unable to save the assessment',
        toggleTextToSpeech: "Unable to toggle 'Text to Speech' setting",
        saveFeedback: 'Unable to save the feedback data',
        saveScore: 'Unable to save the score',
        activateDeactivate: 'Unable to {{action}} the assessment',
        assessmentUsage: 'Unable to fetch assessment usage data',
        loadReports: 'Unable to fetch the reports data',
        assessmentReports: 'Unable to fetch the assessment report data',
        standardtReports: 'Unable to fetch the standard report data',
        studentReports: 'Unable to fetch the student report data',
        studentAssessment: 'Unable to fetch student assessments data',
        standardsMastery: 'Unable to fetch the standards mastery data',
        downloadReports: 'Unable to download the reports',
        equipReports: 'Unable to fetch the equip reports',
        reportSummaryDetails: 'Unable to fetch the report summary details',
        filterOptions: 'Unable to fetch filter options',
        reportsExists: 'Unable to verify if selected reports exists',
        settings: 'Unable to fetch the settings data',
        scheduleSettings: 'Unable to fetch the schedule settings',
        scheduleAssessment: 'Unable to schedule the assessment',
        saveSettings: 'Unable to save the settings data',
        closedAssessment: 'Assessment has already been closed',
        loadQuestion: 'Unable to load question',
        loadStudents: 'Unable to load students',
        featureFlag: 'Unable to fetch feature flags',
    },
};
